export default {
  // this creates a 'Components' folder and a 'AmwalCheckoutButton' subfolder
  title: 'Components/AmwalCheckoutButton',
  parameters: {
    notes: require('./readme.md')
  },
  argTypes: {
    darkMode: {
      options: ['on', 'off', 'auto'],
      control: { type: 'select' },
    },
    locale: {
      options: ['en', 'ar'],
      control: { type: 'select' },
    },
    label: {
      options: ['Quick Checkout', 'Pay with Apple Pay', 'Bank Installments'],
      control: { type: 'select' },
    },
    countryCode: {
      options: ['SA', 'AE'],
      control: { type: 'select' },
    },
    timelineStyle: {
      options: ['default', 'simple'],
      control: { type: 'select' },
    }
  },
};

const Template = (args) =>
    `<amwal-checkout-button
    merchant-id="${args.merchantId}"
    installment-options-url="${args.installmentOptionsUrl}"
    postcode-optional-countries='${JSON.stringify(args.postcodeOptionalCountries)}'
    amount="${args.amount}"
    country-code="${args.countryCode}"
    locale="${args.locale}"
    dark-mode="${args.darkMode}",
    email-required="${args.emailRequired}"
    street2-required="${args.street2Required}"
    initial-email="${args.initialEmail}"
    initial-first-name="${args.initialFirstName}"
    initial-last-name="${args.initialLastName}"
    address-required="${args.addressRequired}"
    initial-address='${JSON.stringify(args.initialAddress)}'
    allowed-address-countries='${JSON.stringify(args.allowedAddressCountries)}'
    allowed-address-states='${JSON.stringify(args.allowedAddressStates)}'
    allowed-address-cities='${JSON.stringify(args.allowedAddressCities)}'
    initial-phone-number="${args.initialPhoneNumber}"
    address-handshake="${args.addressHandShake}"
    send-extra-address-fields="${args.sendExtraAddressFields}"
    shipping-methods='${JSON.stringify(args.shippingMethods)}'
    label='${args.label}'
    taxes="${args.taxes}"
    show-discount-ribbon="${args.showDiscountRibbon}"
    discount="${args.discount}"
    discount-description="${args.discountDescription}"
    fees="${args.fees}"
    fees-description="${args.feesDescription}"
    disabled="${args.disabled}"
    debug="${args.debug}"
    show-payment-brands="${args.showPaymentBrands}"
    show-continue-shopping-button="${args.showContinueShoppingButton}"
    enable-pre-pay-trigger="${args.enablePrePayTrigger}"
    enable-pre-checkout-trigger="${args.enablePreCheckoutTrigger}"
    enable-dynamic-shipping-details="${args.enableDynamicShippingDetails}"
    ref-id="${args.refId}"
    unique-ref="${args.uniqueRef}"
    only-show-bank-installment="${args.onlyShowBankInstallment}"
    enable-apple-checkout="${args.enableAppleCheckout}"
    installments-count="${args.installmentsCount}"
    timeline-style="${args.timelineStyle}"
    footer-message="${args.footerMessage}"
    >
   </amwal-checkout-button>
   <script>
     document.querySelectorAll('amwal-checkout-button').forEach((amwalCheckoutButtonElement) => {
      amwalCheckoutButtonElement.addEventListener('amwalCheckoutSuccess', ev => console.log('amwalCheckoutSuccess', ev.detail) )
      amwalCheckoutButtonElement.addEventListener('updateOrderOnPaymentsuccess', ev => console.log('updateOrderOnPaymentsuccess', ev.detail) )
      amwalCheckoutButtonElement.addEventListener('amwalDismissed', ev => console.log(ev.type, ev.detail) )
      amwalCheckoutButtonElement.addEventListener('amwalAddressUpdate', ev => {
       console.log(ev.type, ev.detail);
       if ( amwalCheckoutButtonElement.getAttribute("address-handshake") === "true" ){
         const newShippingMethods = amwalCheckoutButtonElement.shippingMethods.map(x => {return {...x, price: x.price+1}});
         amwalCheckoutButtonElement.shippingMethods = newShippingMethods;
         amwalCheckoutButtonElement.taxes = amwalCheckoutButtonElement.taxes + 0.01;
         amwalCheckoutButtonElement.discount = amwalCheckoutButtonElement.discount + 0.01;
         amwalCheckoutButtonElement.fees = amwalCheckoutButtonElement.fees + 0.02;
         amwalCheckoutButtonElement.feesDescription = amwalCheckoutButtonElement.feesDescription + " 1";
         amwalCheckoutButtonElement.discountDescription = amwalCheckoutButtonElement.discountDescription + " 1";
         amwalCheckoutButtonElement.amount = amwalCheckoutButtonElement.amount + 0.01;
        setTimeout(() => {
          const event = ${args.addressTriggerError}? new CustomEvent ('amwalAddressTriggerError', {detail: {description: 'weird error'}})
                      : new CustomEvent ('amwalAddressAck');
          amwalCheckoutButtonElement.dispatchEvent(event);
        }, 1000);
       }
      } )
      amwalCheckoutButtonElement.addEventListener('amwalPrePayTrigger', ev => {
       setTimeout(() => {
         const event = ${args.prePayTriggerError}? new CustomEvent ('amwalPrePayTriggerError', {detail: {description: 'weird error'}})
                     : new CustomEvent ('amwalPrePayTriggerAck', {detail: {order_id: 123, order_total_amount: 128}});
         amwalCheckoutButtonElement.dispatchEvent(event);
       }, 1000);
      })
      amwalCheckoutButtonElement.addEventListener('amwalPreCheckoutTrigger', ev => {
        console.log("handling amwalPreCheckoutTrigger")
       setTimeout(() => {
         const event = ${args.preCheckoutTriggerError}? new CustomEvent ('amwalPreCheckoutTriggerError', {detail: {description: 'I could not do it'}})
                     : new Event ('amwalPreCheckoutTriggerAck');
         amwalCheckoutButtonElement.dispatchEvent(event);
       }, 5000);
      })
     });
   </script>`;

// Common default args shared by both stories
const commonArgs = {
  merchantId: "sandbox-amwal-b87482f2-55da-486f-9ec5-e2ceb47a0333",
  amount: 1099,
  countryCode: "SA",
  locale: "ar",
  darkMode: "off",
  initialPhoneNumber: "+18885555512",
  initialFirstName: "John",
  initialLastName: "Smith",
  addressRequired: true,
  initialAddress: {
    street1: "1234 Laurel Street",
    city: "Atlanta",
    state: "GA",
    postcode: "30303",
    country: "US"
  },
  emailRequired: true,
  street2Required: false,
  initialEmail: "John-Appleseed@mac.com",
  addressHandShake: false,
  sendExtraAddressFields: false,
  showPaymentBrands: true,
  disabled: false,
  taxes: 0,
  showDiscountRibbon: true,
  discount: 25,
  discountDescription: "No Discount",
  fees: 0,
  feesDescription: "Installation",
  shippingMethods: [
    {
      id: "free-shipping",
      label: "3 days free shipping",
      price: 0,
    },
    {
      id: "express-shipping",
      label: "1 day delivery",
      price: 10,
    }
  ],
  installmentOptionsUrl: "",
  allowedAddressCountries: ["SA", "AE", "US", "ES", "EG"],
  allowedAddressStates: { "EG": { "EGALX": "Alexandria", "EGASN": "Aswan", "EGAST": "Asyut", "EGBA": "Red Sea", "EGBH": "Beheira", "EGBNS": "Beni Suef", "EGC": "Cairo", "EGDK": "Dakahlia", "EGDT": "Damietta", "EGFYM": "Faiyum", "EGGH": "Gharbia", "EGGZ": "Giza", "EGIS": "Ismailia", "EGJS": "South Sinai", "EGKB": "Qalyubia", "EGKFS": "Kafr el-Sheikh", "EGKN": "Qena", "EGLX": "Luxor", "EGMN": "Minya", "EGMNF": "Monufia", "EGMT": "Matrouh", "EGPTS": "Port Said", "EGSHG": "Sohag", "EGSHR": "Al Sharqia", "EGSIN": "North Sinai", "EGSUZ": "Suez", "EGWAD": "New Valley" }, "SA": { "SA-01": "Riyadh", "SA-02": "Makkah", "SA-03": "Al Madinah", "SA-04": "Eastern Province", "SA-05": "Al-Qassim", "SA-06": "Ha`il", "SA-07": "Tabuk", "SA-08": "Northern Borders", "SA-09": "Jazan", "SA-10": "Najran", "SA-11": "Al-Bahah Region", "SA-12": "Al-Jawf", "SA-14": "Asir" } },
  allowedAddressCities: { "BH": { "BH-13": ["Al Seeb", "Al Amarat", "Bawshar", "Muscat", "Muttrah", "Qurayyat"], "BH-14": ["Nizwa", "Samail", "Bahla", "Adam", "Al Hamra", "Manah", "Izki", "Bid Bid"], "BH-15": ["Sohar", "Shinas", "Liwa", "Saham", "Al Khaboura", "Suwayq"], "BH-17": ["Rustaq", "Al Awabi", "Nakhal", "Wadi al Maawil", "Barka", "Al-Musannah"] }, "KW": { "AA": ["Abdullah Al-Salem", "Adailiya", "Bneid Al Qar"], "HA": ["Al-Bedae", "Bayan", "Hawally"], "AF": ["Abdullah Al-Mubarak", "Airport", "Andalous"] }, "OM": { "MC": ["Al Seeb", "Al Amarat", "Bawshar", "Muscat", "Muttrah", "Qurayyat"], "AD": ["Nizwa", "Samail", "Bahla", "Adam", "Al Hamra", "Manah", "Izki", "Bid Bid"] }, "SA": { "SA-01": ["Afif", "Al Aflaj", "Al Hariq", "Al Majma`ah", "Al Zulfi", "Al-Ghat", "Al-Kharj", "Al-Muzahmiyya", "Al-Quway`iyah", "As Sulayyil", "Dawadmi", "Dhurma", "Diriyah", "Hotat Bani Tamim", "Huraymila", "Riyadh", "Rumah", "Shuqrah", "Thadig", "Wadi ad-Dawasir"], "SA-02": ["Al Jumum", "Al Kamil", "Al Khurmah", "Al Lith", "Al Qunfudhah", "Jeddah", "Khulays", "Mecca", "Rabigh", "Ranyah", "Ta`if", "Turubah"] } },
  debug: true,
  showContinueShoppingButton: true,
  enablePrePayTrigger: false,
  prePayTriggerError: false,
  enablePreCheckoutTrigger: false,
  enableDynamicShippingDetails: false,
  preCheckoutTriggerError: false,
  addressTriggerError: false,
  refId: "1234567890",
  uniqueRef: false,
  postcodeOptionalCountries: ["SA"],
  enableAppleCheckout: false,
  installmentsCount: 12,
  timelineStyle: 'default',
  footerMessage: 'No fees, sharia compliant.'
};

// Story 1: Bank Installments
export const BankInstallments = Template.bind({});
BankInstallments.args = {
  ...commonArgs,
  label: "Bank Installments",
  onlyShowBankInstallment: true,
  addressRequired: false
};

// Story 2: Quick Checkout (on-click checkout)
export const QuickCheckout = Template.bind({});
QuickCheckout.args = {
  ...commonArgs,
  label: "Quick Checkout",
  onlyShowBankInstallment: false,
};

